import { addToast } from 'modules/messageSystem/actions/addToast';
import { addDefaultModal } from 'modules/messageSystem/actions/addModal';


export const handleParticipantHasNotPermission = () => (dispatch) => {
  dispatch(addDefaultModal({
    testId: 'participant-has-no-permission-modal',
    heading: 'const.patientConnectErr',
    body: 'const.tryAgainError',
  }));
};

export const handlePatientCouldNotConnect = () =>
  addToast('failure', 'clinician-unavailable-toast',
    {
      id: 'Appointments.Conversation.GeneralFaliedToConnectSnackbar.Text',
      defaultMessage: '** The call had failed to connect, please try again later.',
    },
    false, null, true, false, null,
    6000,
    'video',
  );
